<template>
  <bwr-icon v-bind="$props" :svg-content="svgContent" />
</template>

<script>
import BwrIcon from './BaseIcon.vue'
import svgContent from '@/icons/thumbsup.svg?raw'
export default {
  name: 'IconThumbsup',
  components: {
    BwrIcon,
  },
  data: () => ({ svgContent }),
}
</script>
